module.exports = __webpack_public_path__ + "static/media/7.bdfe6a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/7.jpg
// module id = 198
// module chunks = 0